interface TotalProps {
    total: number
}

const Total = (props: TotalProps) => {
    const { total } = props

    return <div className="pagination-total">Total {total} items</div>
}

export default Total 